/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ conversation: NonNullable<unknown> }} Notifications_Message_Received_BodyInputs */

const en_notifications_message_received_body = /** @type {(inputs: Notifications_Message_Received_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You received a new message in ${i?.conversation}.`)
};

const pt_br2_notifications_message_received_body = /** @type {(inputs: Notifications_Message_Received_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Você recebeu uma nova mensagem em ${i?.conversation}.`)
};

/**
* | output |
* | --- |
* | "You received a new message in {conversation}." |
*
* @param {Notifications_Message_Received_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_message_received_body = /** @type {((inputs: Notifications_Message_Received_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Received_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_message_received_body(inputs)
	return pt_br2_notifications_message_received_body(inputs)
});